// extracted by mini-css-extract-plugin
module.exports = {"navigationBreakpoint":"1024px","familyMemberBreakpoint":"1024px","inboxBreakpoint":"1024px","blueDark":"#0033a0"};